import { Link } from 'react-router-dom';
import { articles, hotTags } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function ArticleGrid() {
  const hotArticles = articles.filter((a) => a.isHot);
  const recentArticles = articles.filter((a) => !a.isHot).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight">
              最新爆料
            </h2>
            <p className="font-heading text-2xl md:text-3xl text-foreground-400 italic mt-1">
              一手黑料 · 实时追踪
            </p>
          </div>
          <p className="text-foreground-500 text-sm max-w-md leading-relaxed">
            实时更新最新网红明星塌房资讯、私密聊天记录流出、反差视频曝光，让你永远走在吃瓜第一线。
          </p>
        </div>

        <div id="hot-topics" className="mb-12">
          <div className="flex flex-wrap items-center gap-2 mb-6">
            <span className="text-xs font-semibold text-foreground-400 uppercase tracking-wider">热门标签</span>
            {hotTags.map((tag) => (
              <Link
                key={tag}
                to={`/category/influencer-scandal`}
                className="px-3 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                #{tag}
              </Link>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7 mb-12">
          {hotArticles.map((article, idx) => (
            <ArticleCard
              key={article.id}
              article={article}
              variant={idx === 1 ? 'dark-icon' : 'default'}
            />
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {recentArticles.map((article, idx) => (
            <ArticleCard
              key={article.id}
              article={article}
              variant={idx === 1 ? 'dark-icon' : 'default'}
            />
          ))}
        </div>
      </div>
    </section>
  );
}